export const routes = {
    path: 'certificados',
    name: 'BrasilMais_Certificados',
    component: () => import('./Certificados.vue'),
    meta: {
        rules: [],
    }
};